import { z } from 'zod';
import { enumToZodLiteralUnion } from '../../zodExtensions.js';
var TimelineEventTypeEnum;
(function (TimelineEventTypeEnum) {
    TimelineEventTypeEnum["email"] = "email";
    TimelineEventTypeEnum["shipment"] = "shipment";
    TimelineEventTypeEnum["processing"] = "processing";
    TimelineEventTypeEnum["simple"] = "simple";
    TimelineEventTypeEnum["money"] = "money";
    TimelineEventTypeEnum["comment"] = "comment";
    TimelineEventTypeEnum["edit"] = "edit";
    TimelineEventTypeEnum["shopify"] = "shopify";
    TimelineEventTypeEnum["warning"] = "warning";
    TimelineEventTypeEnum["ai"] = "ai";
})(TimelineEventTypeEnum || (TimelineEventTypeEnum = {}));
const textMeta = z.object({
    kind: z.literal('text'),
    label: z.string(),
    value: z.string(),
});
const moneyMeta = z.object({
    kind: z.literal('money'),
    label: z.string(),
    amount: z.number(),
});
const dateMeta = z.object({
    kind: z.literal('date'),
    label: z.string(),
    date: z.iso.datetime(),
});
const linkMeta = z.object({
    kind: z.literal('link'),
    label: z.string(),
    url: z.url(),
    urlLabel: z.string(),
});
// the merchant user who took the action, when one is known
export const timelineUser = z.object({
    email: z.string(),
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    id: z.number(),
});
export const timelineEvent = z.object({
    id: z.string().uuid(),
    datetime: z.string(),
    message: z.string(),
    type: enumToZodLiteralUnion(TimelineEventTypeEnum),
    subject: z.string().optional(),
    user: timelineUser.optional(),
    meta: z
        .array(z.discriminatedUnion('kind', [textMeta, moneyMeta, dateMeta, linkMeta]))
        .optional(),
});
export const timeline = z.array(timelineEvent);
// TODO rename these and related types/content to just "timeline" instead of claim-centric
export const claimTimelineEvent = timelineEvent;
export const claimTimeline = timeline;
//# sourceMappingURL=timeline.js.map